import * as React from "react"
import { IconProps } from "./utils"

export function DatoCMSIcon({
  height = 20,
  width = 20,
}: IconProps): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0001 0.4375H0.4375V19.5625H10.0001C14.7826 19.5625 19.5625 15.281 19.5625 10.0013C19.5625 4.72168 14.7826 0.4375 10.0001 0.4375ZM10.0001 14.3452C9.13519 14.3448 8.28978 14.0897 7.5708 13.6119C6.85182 13.1342 6.29156 12.4554 5.96086 11.6612C5.63017 10.8671 5.54389 9.99342 5.71294 9.15059C5.88199 8.30776 6.29878 7.53366 6.9106 6.92619C7.52242 6.31872 8.3018 5.90515 9.15017 5.73779C9.99854 5.57043 10.8778 5.65678 11.6768 5.98594C12.4758 6.31509 13.1586 6.87227 13.6389 7.587C14.1191 8.30173 14.3753 9.14192 14.3751 10.0013C14.3751 10.572 14.2619 11.1372 14.042 11.6644C13.8221 12.1916 13.4998 12.6707 13.0935 13.0741C12.6872 13.4775 12.2049 13.7974 11.6741 14.0155C11.1433 14.2336 10.5745 14.3456 10.0001 14.3452Z"
        fill="url(#paint0_linear_1772:844)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1772:844"
          x1="0.4375"
          y1="9.99988"
          x2="19.5625"
          y2="9.99988"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF593D" />
          <stop offset="1" stopColor="#FF7751" />
        </linearGradient>
      </defs>
    </svg>
  )
}
